// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"45f1c877","59":"b1e3696f","130":"b1e3696f","222":"b1e3696f","266":"0ff4d2b7","505":"59741473","720":"0ce98235","903":"745ea70e"}[chunkId] + ".chunk.css";
};